///<reference path="commons/xhr.ts" />
///<reference path="typings/jquery.d.ts" />
var InstantSearch = /** @class */ (function () {
    function InstantSearch() {
        this.searchUrl = "/action/suggest?q=";
        this.searchInput = document.getElementById('instant-search');
        this.ulNode = document.getElementById('search-result');
        this.markInstance = new Mark(document.querySelector(".context"));
        if (this.searchInput !== null) {
            this.setEventListener();
        }
    }
    InstantSearch.prototype.setEventListener = function () {
        var _this = this;
        this.searchInput.addEventListener("keyup", function () {
            $('.search-result').addClass('search-result-focused');
            if (this.value.length > 2) {
                _this.doSearchRequest(this.value);
            }
            else if (this.value.length === 0) {
                _this.clearSearchArea();
            }
            else {
                _this.clearSearchArea();
                var searchWarningNode = document.createElement('li');
                searchWarningNode.textContent = "Arama yapabilmek için en az üç karakter girmeniz gerekmektedir.";
                searchWarningNode.className = "warning";
                _this.ulNode.appendChild(searchWarningNode);
            }
        });
        window.addEventListener('click', function () {
            if (!$('#instant-search').is(':focus')) {
                $('.search-result').removeClass('search-result-focused');
                $('#instant-search').val('');
            }
        });
    };
    InstantSearch.prototype.doSearchRequest = function (value) {
        var _this = this;
        var xhr = new Xhr();
        var requestUrl = this.searchUrl + value;
        xhr.getJSON(requestUrl, function (data) {
            //alert('Sonuç' + data[0].Title);
            _this.setHtmlContent(data, value);
        }, function (status) {
            //alert('Birşeyler ters gitti');
        });
    };
    InstantSearch.prototype.setHtmlContent = function (data, value) {
        this.clearSearchArea();
        var _this = this;
        Object.keys(data).forEach(function (key) {
            var listNode = document.createElement('li');
            var linkNode = document.createElement('a');
            linkNode.textContent = data[key].Title;
            linkNode.setAttribute('href', data[key].Url);
            listNode.appendChild(linkNode);
            _this.ulNode.appendChild(listNode);
        });
        var moreListNode = document.createElement('li');
        var moreLinkNode = document.createElement('a');
        moreLinkNode.textContent = "> Daha Fazla Sonuç";
        moreLinkNode.setAttribute('href', '/arama?q=' + value);
        moreListNode.appendChild(moreLinkNode);
        _this.ulNode.appendChild(moreListNode);
        _this.markInstance.unmark().mark(value);
    };
    InstantSearch.prototype.clearSearchArea = function () {
        var _this = this;
        while (_this.ulNode.firstChild) {
            _this.ulNode.removeChild(_this.ulNode.firstChild);
        }
    };
    return InstantSearch;
}());
var search = new InstantSearch();
//# sourceMappingURL=instantSearch.js.map